import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { AnimatePresence } from "framer-motion";
import { Background } from "@/components/landing/Background";
import { Preloader } from "@/components/landing/Preloader";
import { Marquee } from "@/components/landing/Marquee";
import { Header } from "@/components/site/Header";
import { Hero3D } from "@/components/site/Hero3D";
import { FounderCampaign } from "@/components/site/FounderCampaign";
import { FeatureSections, SafetySection } from "@/components/site/FeatureSections";
import { CreatorEarnings, About, FAQ } from "@/components/site/HomeExtras";
import { Footer } from "@/components/site/Footer";
import { CookieConsent } from "@/components/site/CookieConsent";
import { useSEO } from "@/hooks/useSEO";

export default function Home() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useSEO({
    title: "IND RIL | India's Own Social Media Platform",
    description: "Create, share and connect on IND RIL — a creator-first social platform for videos, photos, stories and conversations.",
    path: "/",
  });

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (loading) return;
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, [loading, location.hash]);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <AnimatePresence>{loading && <Preloader key="pre" />}</AnimatePresence>
      <div className="noise-overlay" />
      <Background />
      <main className="relative">
        <Header />
        <Hero3D />
        <FounderCampaign />
        <Marquee />
        <FeatureSections />
        <SafetySection />
        <CreatorEarnings />
        <About />
        <FAQ />
        <Footer />
      </main>
      <CookieConsent />
    </ReactLenis>
  );
}
